import React from 'react';

export default function Footer() {
  return <footer className="site-footer page-width"><small>© {new Date().getFullYear()} K1r44</small><a href="https://github.com/k1r4-id" target="_blank" rel="noopener noreferrer">github.com/k1r4-id</a><a href="#main-content">Back to top</a></footer>;
}
